module.exports = __webpack_public_path__ + "img/bg-gery.84ddc850.png";